import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true, // 🔑
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  isHidden = true;
  isHidden2 = true;

  private visibleRoutes: string[] = [
    '/uima/home',
    '/uima/login', 
  ];
  private visibleRoutes2: string[] = [
    '/uima/home',
    '/uima/login', 
    '/uima/PMBportal', 
  ];
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isHidden = !this.visibleRoutes.includes(event.urlAfterRedirects);
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isHidden2 = !this.visibleRoutes2.includes(event.urlAfterRedirects);
      }
    });
  }
}
